<div
    class="tier"
    [ngClass]="{
        active: isActive,
        auto: !showSelect,
        subscribed: userTier?.id == tier.id,
        unavailable: userTier && userTier.order > tier.order
    }"
>
    <div class="inner">
        <div class="name">{{ tier.name }}</div>
        <div class="price" [ngClass]="'color-' + tier.order">
            <div *ngIf="tier">
                <strong>
                    ${{ dollars | number }}<span class="cents">{{ cents }}</span>
                </strong>
                <em>
                    <span *ngIf="tier.billingInterval == 1"> / month</span>
                    <span *ngIf="tier.billingInterval != 1"> / {{ tier.billingInterval }} months</span>
                </em>
            </div>

            <div *ngIf="!tier">
                <strong>US$-.--</strong>
            </div>
        </div>
        <div class="info">
            <p class="description" *ngIf="tier.description">
                {{ tier.description }}
            </p>

            <ul *ngIf="tier.benefits && tier.benefits.length > 0">
                <li *ngFor="let b of tier.benefits">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <p>{{ b.name }}</p>
                </li>
            </ul>
        </div>
        <div class="action" *ngIf="showSelect">
            <button class="btn btn-dark" (click)="onSelect()" *ngIf="!isActive && userTier?.id != tier.id">
                <span *ngIf="userTier && userTier.order < tier.order">Upgrade</span>
                <span *ngIf="userTier && userTier.order > tier.order">Unavailable</span>
                <span *ngIf="!userTier">Select Plan</span>
            </button>
            <button class="btn btn-dark selected" (click)="onSelect()" *ngIf="isActive && userTier?.id != tier.id">
                Selected
            </button>
            <button class="btn btn-dark subscribed" *ngIf="userTier?.id == tier.id">Subscribed</button>
        </div>
    </div>
</div>
